var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.833 0.389202L11.7081 7.93918H11.7075C11.2724 8.29929 10.6407 8.29929 10.2056 7.93918L1.08398 0.387261C1.45896 0.142232 1.9057 0 2.38671 0H19.5271C20.0094 0 20.4574 0.143527 20.833 0.389202ZM9.66987 8.71092C10.0494 9.00185 10.5039 9.14797 10.9584 9.14797C11.4142 9.14797 11.87 9.00121 12.2495 8.70898L20.991 15.4347C20.5869 15.7489 20.08 15.9357 19.5286 15.9357H2.38819C1.83736 15.9357 1.32985 15.7482 0.925781 15.4347L9.66987 8.71092ZM0.411183 1.04785L0.410951 1.04819L0.410536 1.04785H0.411183ZM0.410951 1.04819L8.92576 8.09743L0.30968 14.7229C0.11314 14.3757 0 13.9749 0 13.5475V2.38743C0 1.89105 0.151841 1.43022 0.410951 1.04819ZM21.5068 1.05078C21.7647 1.43222 21.9154 1.89189 21.9154 2.38712V2.38777V13.5479C21.9154 13.9752 21.8029 14.3761 21.6063 14.7232L12.9922 8.09584L21.5068 1.05078Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.a846858c2aaa1b84d78cecaab2d71445.svg";
export { ForwardRef as ReactComponent };